import { render, staticRenderFns } from "./oncall.vue?vue&type=template&id=4e347aa1&"
import script from "./oncall.vue?vue&type=script&lang=ts&"
export * from "./oncall.vue?vue&type=script&lang=ts&"
import style0 from "./oncall.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports